import { mpEventInfo } from '@/constant'
import type { DefaultResponse, Pagination, SmsResponse } from '@/types/common'
import maxios from '@/utils/axios/maxios'

// 문자 API
const SmsApi = {
  /* 템플릿*/
  // SMS 템플릿 목록 가져오기
  getSmsTemplate(pageQueryString: string) {
    return maxios.get<Pagination<res.SmsTemplate[]>>(`/sms/templates${pageQueryString}`, {
      params: { mp_event_name: mpEventInfo.문자템플릿조회 },
    })
  },
  // SMS 템플릿 생성하기
  postSmsTemplate(template: req.SmsTemplate) {
    return maxios.post('/sms/templates', template, {
      params: { mp_event_name: mpEventInfo.문자발송결과조회 },
    })
  },
  // 특정 SMS 템플릿 수정하기
  patchSmsTemplate(templateId: res.SmsTemplate['id'], template: req.SmsTemplate) {
    return maxios.patch(`/sms/templates/${templateId}`, template, {
      params: { mp_event_name: mpEventInfo.문자템플릿수정 },
    })
  },
  // 특정 SMS 템플릿 삭제하기
  deleteSmsTemplateByIds(ids: req.SmsTemplateIds) {
    return maxios({
      url: '/sms/templates',
      method: 'DELETE',
      data: ids,
      params: { mp_event_name: mpEventInfo.문자템플릿삭제 },
    })
  },
  getAttendanceSmsSample(params: req.AttendanceSmsSampleParams) {
    return maxios.get<DefaultResponse<res.AttendanceSmsSample>>('/sms/templates/samples', {
      params: { ...params, mp_event_name: mpEventInfo.문자발송될샘플조회 },
    })
  },
  // SMS 베이직 템플릿 조회 by sending type
  getSmsBasicTemplateBySendingType(templateSendingType: res.SmsTemplate['templateSendingType']) {
    return maxios.get<res.SmsTemplate>('/sms/basic-templates/by-sending-type', {
      params: { templateSendingType, mp_event_name: mpEventInfo.문자템플릿조회 },
    })
  },

  // 문자 발송하기
  postSms(data: req.SmsSend) {
    return maxios.post('/sms/direct', data, {
      params: { mp_event_name: mpEventInfo.문자발송 },
    })
  },

  // SMS 발송 결과 가져오기 - by Id
  getSmsById(params: req.SmsRecipient, pageQueryString: string) {
    return maxios.get<SmsResponse<res.Sms[]>>(`/sms${pageQueryString}`, {
      params: { ...params, mp_event_name: mpEventInfo.문자발송결과조회 },
    })
  },
  // SMS 발송 결과 가져오기 - by Date
  getSmsByDate(params: req.SmsByDate, pageQueryString: string) {
    return maxios.get<SmsResponse<res.Sms[]>>(`/sms${pageQueryString}`, {
      params: { ...params, mp_event_name: mpEventInfo.문자발송결과조회 },
    })
  },

  postIdGuideSms(data: req.IdGuideSms) {
    return maxios.post('/sms', data, {
      params: { mp_event_name: mpEventInfo.문자템플릿기반문자발송 },
    })
  },
}

export default SmsApi
